/* NEW: UI_REVAMP */
import { Box, Text, useRadio } from '@chakra-ui/react';
import React from 'react';
import SelectionButton from '../button/SelectionButton';
import { RECORD_GRADIENTS } from '../../styles/recordUiTokens';

export function RadioCard(props) {
	const { getInputProps, getCheckboxProps } = useRadio(props);
	const input = getInputProps();
	const checkbox = getCheckboxProps();
	const isSelected = Boolean(props.name);
	const isTransaction = Boolean(props.isTransaction);

	return (
		<Box as='label'>
			<input {...input} />
			<Box
				{...checkbox}
				cursor='pointer'
				display='flex'
				alignItems='center'
				justifyContent='center'
				minHeight={isTransaction ? '43px' : '40px'}
				borderRadius={isTransaction ? '8px' : '12px'}
				borderWidth='1px'
				borderColor={isSelected ? (isTransaction ? '#FF8A00' : '#D0D7E2') : '#E6E6E6'}
				boxShadow={isSelected && isTransaction ? '0 2px 6px rgba(255, 153, 20, 0.28)' : 'sm'}
				fontSize='14px'
				fontWeight='600'
				lineHeight='100%'
				color={isSelected ? '#292929' : '#3E2A21'}
				background={
					isSelected ? (isTransaction ? RECORD_GRADIENTS.filterActive : '#ECF2FF') : '#FFFFFF'
				}
			>
				{props.children}
			</Box>
		</Box>
	);
}

export function SiteFilterOptionCard(props) {
	const { getInputProps, getCheckboxProps } = useRadio(props);
	const input = getInputProps();
	const checkbox = getCheckboxProps();
	const isSelected = Boolean(props.isSelected);
	const {
		height = '40px',
		borderRadius = '8px',
		fontSize = '16px',
		fontWeight = '600',
		flex = '1',
		inactiveColor = '#2D0707',
		px = 4,
		py = 2,
	} = props;

	return (
		<Box as='label' flex={flex}>
			<input {...input} />
			<Box {...checkbox} width='100%'>
				<SelectionButton
					variant='betTypePick'
					status={isSelected ? 'selected' : 'default'}
					h={height}
					p={`${py} ${px}`}
					borderRadius={borderRadius}
					w='100%'
					pointerEvents='none'
				>
					<Text
						fontSize={fontSize}
						fontWeight={fontWeight}
						lineHeight='100%'
						color={isSelected ? '#FFFFFF' : inactiveColor}
					>
						{props.children}
					</Text>
				</SelectionButton>
			</Box>
		</Box>
	);
}

export function StatusFilterOptionCard(props) {
	const { getInputProps, getCheckboxProps } = useRadio(props);
	const input = getInputProps();
	const checkbox = getCheckboxProps();
	const isSelected = Boolean(props.isSelected);
	const {
		height = '40px',
		borderRadius = '8px',
		fontSize = '14px',
		fontWeight = '600',
		px = 4,
		py = 2,
	} = props;

	return (
		<Box as='label'>
			<input {...input} />
			<Box {...checkbox} width='100%'>
				<SelectionButton
					variant='timePick'
					status={isSelected ? 'selected' : 'default'}
					h={height}
					p={`${py} ${px}`}
					borderRadius={borderRadius}
					w='100%'
					pointerEvents='none'
				>
					<Text fontSize={fontSize} fontWeight={fontWeight} lineHeight='100%' color='inherit'>
						{props.children}
					</Text>
				</SelectionButton>
			</Box>
		</Box>
	);
}
